import React, { useState, useEffect, useReducer } from 'react';
import { Link, useParams } from 'react-router-dom'
import _ from 'lodash'
import Header from '../../../header/Header'
import Footer from '../../../footer/Footer'
import ScrollView from 'devextreme-react/scroll-view';
import Gallery from 'devextreme-react/gallery';
import { Toast } from 'devextreme-react/toast';
import moment from 'moment';
import { confirm } from 'devextreme/ui/dialog';
import {
    Popup
} from 'devextreme-react/popup';
import kaizenReducer from '../../../../reducers/kaizen';
import * as action from '../../../../actions/kaizen';

const scrollConfig = {
    showScrollbar: 'always',
    scrollByContent: true,
    scrollByThumb: false,
}

const initialState = { allNominated: [] }

const NominatedCard = ({ data, setSelectedData, setIsPopupVisible, manageNomination }) => {
    const { kaizenTitle, kaizenIdea, proposer, proposersDepartment } = data;
    return <div className="nomination_card_container">
        <h4 className="nomination_card_heading">{kaizenTitle}</h4>
        <div className="nomination_card_description">{kaizenIdea}</div>
        <div className="nomination_card_by">{proposer}</div>
        <div className="nomination_card_status">{proposersDepartment}</div>
        <div className="nomination_card_actions">
            <a style={{ fontSize: "1.05rem" }} onClick={() => {
                setSelectedData(data)
                setIsPopupVisible(true)
            }}>View Details</a>
            {
                data.recognition != 'Rejected' && data.recognizedKaizen !== true
                    ? <>
                        <span onClick={() => manageNomination(data, 'Approved')} style={{ color: '#1ca8dd' }} title="Approve">
                            <i className="dx-icon-todo" style={{ fontSize: "1.30rem" }}></i>
                        </span>
                        <span onClick={() => manageNomination(data, 'Rejected')} style={{ color: '#FF0000', paddingLeft: "10px" }} title="Reject">
                            <i className="dx-icon-remove" style={{ fontSize: "1.30rem" }}></i>
                        </span>
                    </>
                    : data.recognition === 'Rejected'
                        ? <>
                            <span style={{ color: '#FF0000' }}>
                                <h5 style={{ fontSize: "1.04rem" }}>Rejected</h5>
                            </span>
                        </>
                        :
                        <>
                            <span style={{ color: '#00FF00' }} >
                                <h5 style={{ fontSize: "1.04rem" }}>Recognised Kaizen</h5>
                            </span>
                        </>
            }
        </div>
    </div>
}

const NominatedKaizen = props => {
    const { category, site } = useParams()
    const [animate, setAnimate] = useState(null)
    const [selectedData, setSelectedData] = useState(null);
    const [dataList, setDataList] = useState([])
    const [state, dispatch] = useReducer(kaizenReducer, initialState);
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [toastConfig, setToastConfig] = useState({ isVisible: false, type: 'info', message: '' });

    const { allNominated } = state;

    useEffect(() => {
        action.fetchAdminNominatedKaizenData(dispatch, site)
    }, [])

    useEffect(() => {
        if (selectedData) {
            let a = allNominated.find(val => val.id == selectedData.id)
            setSelectedData(a);
        }
    }, [allNominated])

    useEffect(() => {
        const perChunk = 6 // items per chunk    

        const result = allNominated.reduce((resultArray, item, index) => {
            const chunkIndex = Math.floor(index / perChunk)

            if (!resultArray[chunkIndex]) {
                resultArray[chunkIndex] = [] // start a new chunk
            }

            resultArray[chunkIndex].push(item)

            return resultArray
        }, [])
        setDataList(result)
    }, [allNominated])

    useEffect(() => {
        setTimeout(() => {
            setAnimate('animate')
        }, 250);
    }, []);

    useEffect(() => {
    }, [isPopupVisible])


    const manageNomination = (data, val) => {
        confirm(`Are you sure that you wanted to ${val === 'Approved' ? 'approve' : 'reject'} the kaizen for nomination?`, 'Nominate Kaizen')
            .then((res) => {
                if (res) {
                    const payload = {
                        ...data,
                        nominationStatus: val === 'Approved' ? 'Approved' : 'Rejected',
                    }
                    action.manageAdminNominatedKaizenData(dispatch, payload)
                    setToastConfig({
                        ...toastConfig, isVisible: true, type: 'success', message: `Kaizen ${val === 'Approved' ? 'Approved' : 'Rejected'} Successfully.`
                    });
                }
            })
            .catch(err => console.log(err))
    }

    const gridRenderer = (data) => {
        return <div className="nomination_carousel_data">
            {data && data.map(data => {
                return <>
                    <NominatedCard data={data} setSelectedData={setSelectedData} manageNomination={manageNomination} setIsPopupVisible={setIsPopupVisible} />
                </>
            })}
        </div>
    }

    return (
        <>
            <Header showPinBtn={false} site={[]} />

            <section className="page-content">
                <div className="site-view tier-wrap">
                    <div className={"site-list " + animate}>
                        <div className="breadcrumb">
                            <span className="icon icon-corporate"></span>
                            <ul>
                                <li><Link to={`/`}>Home</Link></li>
                                <li><Link to={`/siteApp/${category}/${site}/kaizen`}>Kaizen</Link></li>
                                <li><b>Nominated Kaizen</b></li>
                            </ul>
                            <div className="d-flex nomination-statuses" style={{ justifyContent: "flex-end", width: '80%' }}>
                                <div className="d-flex nomination-statuses" style={{ marginRight: "10px" }}>
                                    <div className="not-nominated"></div>
                                    <div>Total Count:{`${allNominated.length}`} </div>
                                </div>
                            </div>
                        </div>

                        {allNominated && allNominated.length > 0
                            ?
                            <div className="nomination_container site-body scroll">
                                <ScrollView
                                    id="tierApps"
                                    {...scrollConfig}
                                >
                                    <Gallery
                                        id="gallery"
                                        dataSource={dataList}
                                        height='100%'
                                        width='100%'
                                        showNavButtons={dataList.length > 1}
                                        showIndicator={false}
                                        itemRender={gridRenderer} />
                                </ScrollView>
                            </div>
                            : <div className="nomination_container site-body scroll">
                                <span style={{ width: '100%', marginLeft: '40%' }}>
                                    <h3>No Kaizen To Nominate</h3>
                                </span>
                            </div>
                        }
                    </div>
                </div>
            </section>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Footer showThemeSwitch={true} container="admin-console" hideSiteCount={true} activeSites={[]} sbg={[]} />
            </div>
            <Toast
                visible={toastConfig.isVisible}
                message={toastConfig.message}
                type={toastConfig.type}
                onHiding={() => setToastConfig({
                    ...toastConfig,
                    isVisible: false,
                })}
                displayTime={2000}
            />
            {
                isPopupVisible &&
                <Popup
                    mode="popup"
                    width={1400}
                    height="content-fit"
                    showTitle={true}
                    title={selectedData.kaizenTitle}
                    dragEnabled={false}
                    hideOnOutsideClick={true}
                    onHiding={() => {
                        setIsPopupVisible(false)
                        selectedData(null)
                    }}
                    visible={isPopupVisible}
                    focusStateEnabled={false}
                >
                    <ScrollView
                        id="scrollview"
                        {...scrollConfig}
                    >
                        <div className="d-flex kreg-info">
                            <div className=" alerts-flex-container nomination-popup" >
                                <div className="kreg-item">
                                    <label >Category</label>
                                    <span> {selectedData.category || '-'}</span>
                                </div>

                                <div className="kreg-item">
                                    <label >TTI Category</label>
                                    <span> {selectedData.ttiCategory || '-'}</span>
                                </div>
                                <div className="kreg-item">
                                    <label >Lines</label>
                                    <span> {selectedData.lines || '-'}</span>
                                </div>
                                <div className="kreg-item">
                                    <label >Status</label>
                                    <span> {selectedData.status || '-'}</span>
                                </div>
                                <div className="kreg-item">
                                    <label >Collaborated With</label>
                                    <span> {selectedData?.assignedTo || '-'}</span>
                                </div>
                                <div className="kreg-item">
                                    <label >Cost/Revenue Impact($)</label>
                                    <span> {selectedData.costImpact}</span>
                                </div>
                                <div className="kreg-item nomination-description">
                                    <label >Description</label>
                                    <span> {selectedData.kaizenIdea}</span>
                                </div>
                                <br />
                                <div className="kreg-item w-100">
                                    <label >Attachments</label>
                                    <span>No files attached</span>
                                </div>
                            </div>
                            <div className="alerts-flex-container nomination-popup" >
                                <div className="kreg-item">
                                    <label >Area</label>
                                    <span> {selectedData.location || '-'}</span>
                                </div>

                                <div className="kreg-item">
                                    <label >Cell</label>
                                    <span> {selectedData.module || '-'}</span>
                                </div>

                                <div className="kreg-item">
                                    <label >Proposer</label>
                                    <span> {selectedData.proposer || '-'}</span>
                                </div>
                                <div className="kreg-item">
                                    <label >Approver</label>
                                    <span> {selectedData.ttiApprover || '-'}</span>
                                </div>

                                <div className="kreg-item">
                                    <label >Raised On</label>
                                    <span> {selectedData.created ? moment(selectedData.created).format('MM/DD/YYYY') : '-'}</span>
                                </div>
                                <div className="kreg-item">
                                    <label >Completed On</label>
                                    <span> {selectedData.completedDat ? moment(selectedData.completedDate).format('MM/DD/YYYY') : '-'}</span>
                                </div>

                                <div className="kreg-item">
                                    <label >Solution</label>
                                    <span> {selectedData.actionTaken || '-'}</span>
                                </div>
                            </div>
                        </div>
                        <div className={'d-flex nomination-bottom-buttons p-3'}>
                            {selectedData.recognition != 'Rejected' && selectedData.recognizedKaizen !== true
                                ? <>
                                    <span onClick={() => manageNomination(selectedData, 'Approved')} style={{ color: '#1ca8dd' }} title="Approve">
                                        <i className="dx-icon-todo" style={{ fontSize: "1.30rem" }}></i>
                                    </span>
                                    <span onClick={() => manageNomination(selectedData, 'Rejected')} style={{ color: '#FF0000', paddingLeft: "10px" }} title="Reject">
                                        <i className="dx-icon-remove" style={{ fontSize: "1.30rem" }}></i>

                                    </span>
                                </>
                                : selectedData.recognition === 'Rejected'
                                    ? <>
                                        <span style={{ color: '#FF0000' }}>
                                            <h5 style={{ fontSize: "1.04rem" }}>Rejected</h5>
                                        </span>
                                    </>
                                    :
                                    <>
                                        <span style={{ color: '#00FF00' }} >
                                            <h5 style={{ fontSize: "1.04rem" }}>Recognised Kaizen</h5>
                                        </span>
                                    </>
                            }
                        </div>
                    </ScrollView>
                </Popup>
            }
        </>
    )
};
export default NominatedKaizen